import { render } from "./IconGhgEmission.vue?vue&type=template&id=3e45254e"
import script from "./IconGhgEmission.vue?vue&type=script&lang=ts"
export * from "./IconGhgEmission.vue?vue&type=script&lang=ts"
script.render = render

export default script